module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-1467-min.a91d5ff3.jpg";